.Animation {
  transition: var(--brand-animation-transition-default);
}

/**
 * Fade in
 */
.Animation--fade-in {
  opacity: 0;
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--fade-in.Animation--active {
  opacity: 1;
}

/**
 * Fade out
 */
.Animation--fade-out {
  opacity: 1;
}

.Animation--fade-out.Animation--active {
  opacity: 0;
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

/**
 * Slide in up
 */
.Animation--slide-in-up {
  opacity: 0;
  transform: translateY(var(--brand-animation-variant-slideInUp-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--slide-in-up.Animation--active {
  opacity: 1;
  transform: translateY(0);
}

/**
 * Slide in down
 */
.Animation--slide-in-down {
  opacity: 0;
  transform: translateY(var(--brand-animation-variant-slideInDown-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--slide-in-down.Animation--active {
  opacity: 1;
  transform: translateY(0);
}

/**
 * Slide in left
 */
.Animation--slide-in-left {
  opacity: 0;
  transform: translateX(var(--brand-animation-variant-slideInLeft-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--slide-in-left.Animation--active {
  opacity: 1;
  transform: translateX(0);
}

/**
 * Slide in right
 */
.Animation--slide-in-right {
  opacity: 0;
  transform: translateX(var(--brand-animation-variant-slideInRight-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--slide-in-right.Animation--active {
  opacity: 1;
  transform: translateX(0);
}

/**
 * Scale in
 */
.Animation--scale-in {
  opacity: 0;
  transform: scale(var(--brand-animation-variant-scaleIn-start));
  transition: opacity var(--brand-animation-duration-extended) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-extended) var(--brand-animation-easing-default);
}

.Animation--scale-in.Animation--active {
  opacity: 1;
  transform: scale(--brand-animation-variant-scaleIn-end);
}

/**
 * Scale in up
 */
.Animation--scale-in-up {
  opacity: 0;
  transform: scale(var(--brand-animation-variant-scaleInUp-start))
    translateY(var(--brand-animation-variant-scaleInUp-distance));
  transition: opacity var(--brand-animation-duration-extended) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-extended) var(--brand-animation-easing-default);
}

.Animation--scale-in-up.Animation--active {
  opacity: 1;
  transform: scale(var(--brand-animation-variant-scaleInUp-end)) translateY(0);
}

/**
 * Scale in down
 */
.Animation--scale-in-down {
  opacity: 0;
  transform: translateY(var(--brand-animation-variant-scaleInDown-distance))
    scale(var(--brand-animation-variant-scaleInDown-start));
  transition: opacity var(--brand-animation-duration-extended) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-extended) var(--brand-animation-easing-default);
}

.Animation--scale-in-down.Animation--active {
  opacity: 1;
  transform: translateY(0) scale(var(--brand-animation-variant-scaleInDown-end));
}

/**
 * Scale in right
 */
.Animation--scale-in-right {
  opacity: 0;
  transform: scale(var(--brand-animation-variant-scaleInRight-start))
    translateX(var(--brand-animation-variant-scaleInRight-distance));
  transition: opacity var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--scale-in-right.Animation--active {
  opacity: 1;
  transform: translateX(0) scale(var(--brand-animation-variant-scaleInRight-end));
}

/**
 * Scale in left
 */
.Animation--scale-in-left {
  opacity: 0;
  transform: scale(var(--brand-animation-variant-scaleInLeft-start))
    translateX(var(--brand-animation-variant-scaleInLeft-distance));
  transition: opacity var(--brand-animation-duration-extended) var(--brand-animation-easing-default),
    transform var(--brand-animation-duration-extended) var(--brand-animation-easing-default);
}

.Animation--scale-in-left.Animation--active {
  opacity: 1;
  transform: translateX(0) scale(var(--brand-animation-variant-scaleInLeft-end));
}

/**
 * Fill in right
 */
.Animation--fill-in-right {
  transform-origin: left;
  transform: scaleX(0);
  transition: transform var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--fill-in-right.Animation--active {
  transform: scaleX(1);
}

/**
 * Scale in top
 */
.Animation--fill-in-top {
  transform-origin: top;
  transform: scaleY(0);
  transition: transform var(--brand-animation-duration-extended) var(--brand-animation-easing-default);
}

.Animation--fill-in-top.Animation--active {
  transform: scaleY(1);
}

/**
 * Wipe in up
 */
.Animation--reveal-in-up {
  transform: translateY(100%);
  clip-path: inset(-100% 0 100% 0);
  transition: transform var(--brand-animation-duration-default) var(--brand-animation-easing-default),
    clip-path var(--brand-animation-duration-default) var(--brand-animation-easing-default);
}

.Animation--reveal-in-up.Animation--active {
  transform: translateY(0);
  clip-path: inset(0 0 -0.2em 0); /* includs some offset to account for descenders  */
}

/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  .Animation,
  .Animation::before,
  .Animation::after,
  .Animation * {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
